import { useState, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { fetchUserProfile } from '../lib/api';

export function useUserRole() {
  const { user, isLoaded } = useUser();
  const [profileRole, setProfileRole] = useState<string | null>(null);
  const [loadingProfile, setLoadingProfile] = useState<boolean>(true);

  useEffect(() => {
    if (!isLoaded || !user) {
      setLoadingProfile(false);
      return;
    }

    let isMounted = true;

    async function checkRole() {
      try {
        const profile = await fetchUserProfile(user!.id);
        if (isMounted && profile) {
          setProfileRole(profile.role);
        }
      } catch (err) {
        console.error('Kullanıcı rolü sorgulanırken hata:', err);
      } finally {
        if (isMounted) setLoadingProfile(false);
      }
    }

    checkRole();

    return () => {
      isMounted = false;
    };
  }, [user, isLoaded]);

  // Root admin ID'si
  const isRootAdmin = user?.id === 'user_3FMl5C9CElnYwGOmdIDBIzxmLy3';

  // Clerk metadata rolü
  const clerkRole = (user?.publicMetadata?.role as string)?.toLowerCase();

  // Supabase db rolü
  const dbRole = profileRole?.toLowerCase();

  // Varsayılan rol 'student' (Öğrenci)dir. Tüm üyeler varsayılan olarak öğrenci açılır.
  // Root admin, profiles/Clerk metadata'da başka bir rol kayıtlı olsa bile her zaman admin sayılır.
  const activeRole = isRootAdmin ? 'admin' : dbRole || clerkRole || 'student';

  // Yalnızca Eğitmen ('educator' / 'egitmen'), Yetkili Satıcı ('seller' / 'satici') veya Yönetici ('admin') yetkili kullanıcılar Öğretmen Stüdyosuna erişebilir.
  const ALLOWED_TEACHER_ROLES = ['educator', 'teacher', 'seller', 'admin', 'yonetici', 'egitmen', 'satici'];
  const isTeacher = isRootAdmin || ALLOWED_TEACHER_ROLES.includes(activeRole);

  return {
    isLoaded: isLoaded && !loadingProfile,
    isTeacher: Boolean(isTeacher),
    isRootAdmin,
    role: activeRole,
    user,
  };
}
